import axios from 'axios'
import { GetHeaderWithToken } from '../../../../../resources/Utils'
import serviceBase from '../../../../Services/serviceBase'

class RecruitmentActions
{
  getRecruitment = async (identifier) =>
  {
    let url = `${window._env_.COMMUNITY_API_URL}/recruitment/recruitment-by-department/${identifier}`
    return axios.get(url, GetHeaderWithToken()).then(
      (response) =>
      {
        if (response && response.data)
        {
          return response.data
        } else
        {
          return {
            sectionActive: false,
            sectionName: 0,
            bodyText: '',
            positionFiles: 0,
            postMessage: '',
            images: [],
            videos: []
          }
        }
      },
      (err) => { }
    )
  }

  getRecruitmentPreview = async (identifier) =>
  {
    let url = `${window._env_.COMMUNITY_API_URL}/recruitment-preview/by-department/${identifier}`
    return axios.get(url, GetHeaderWithToken()).then(
      (response) =>
      {
        if (response && response.data)
        {
          return response.data
        } else
        {
          return {
            sectionActive: true,
            sectionName: 0,
            bodyText: '',
            positionFiles: 0,
            postMessage: '',
            images: [],
            videos: []
          }
        }
      },
      (err) => { }
    )
  }

  postPublishRecruitment = async (fireDepartmentIdentifier) =>
  {
    let url = `${window._env_.COMMUNITY_API_URL}/recruitment-preview/publish/${fireDepartmentIdentifier}`
    return serviceBase.post(url).then(
      (response) =>
      {
        return response.data
      },
      (err) => { }
    )
  }
}
export default new RecruitmentActions()
